import { effect, signal } from '@preact/signals';

import { setPictoSet, type PictoSet } from '@amumin/ui-core';

import { context } from './session.js';

// Pictogrammen in de ouderapp (feat/themas, docs/ux/themas.md): standaard de rustige lijnset
// ("strak"), op verzoek de kleurrijke ("speels"). Per gebruiker in deze browser (localStorage),
// zoals trillen; alleen "speels" wordt bewaard. Het bord kiest zelf per thema en scherm.

const key = (): string => `fb.picto.${context.value?.identity.id ?? 'anon'}`;

function read(k: string): PictoSet {
  try {
    return window.localStorage.getItem(k) === 'color' ? 'color' : 'clean';
  } catch {
    return 'clean';
  }
}

/** De keuze van de ingelogde gebruiker (Mijn thema). */
export const appPictoSet = signal<PictoSet>('clean');

export function chooseAppPictoSet(next: PictoSet): void {
  appPictoSet.value = next;
  try {
    if (next === 'clean') window.localStorage.removeItem(key());
    else window.localStorage.setItem(key(), next);
  } catch {
    // Geen opslag (privévenster): de keuze geldt tot herladen.
  }
}

/** De keuze volgen bij wisselen van gebruiker en doorgeven aan alle pictogrammen. */
export function installAppPictoSet(): () => void {
  const stopUser = effect(() => {
    appPictoSet.value = read(key());
  });
  const stopSet = effect(() => setPictoSet(appPictoSet.value));
  return () => {
    stopUser();
    stopSet();
  };
}
